import { render, staticRenderFns } from "./detection-tag.vue?vue&type=template&id=25e44ed9&"
import script from "./detection-tag.vue?vue&type=script&lang=js&"
export * from "./detection-tag.vue?vue&type=script&lang=js&"
import style0 from "./detection-tag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports